import React, { useState } from "react";
import s from "./Checkbox.module.scss";
import {createGuid} from "../../../../util/string-util";

interface ICheckbox {
  name: string;
  isChecked: boolean;
  label?: string;
  onChange?: (isChecked: boolean) => void;
  tooltip?: string;
  isReadonly?: boolean;
}

export default function Checkbox({name, isChecked, label = "", onChange, tooltip, isReadonly}: ICheckbox) {
  const guid = createGuid();
  const tooltipText = tooltip ? tooltip : "";

  const [localIsChecked, setLocalIsChecked] = useState(isChecked);

  return (
    <div className={`${s.container}`}
      title={tooltipText}>
      <input
        className={s.checkBox}
        type="checkbox"
        id={guid}
        name={name}
        checked={localIsChecked}
        onChange={(e) => {
          const target = e.target as HTMLInputElement;
          setLocalIsChecked(target.checked);

          if (onChange) {
            onChange(target.checked ?? false);
          }
        }}
        disabled={isReadonly}
      />
      {
        label.length > 0
          ? <label className={s.label} htmlFor={guid}>
            {label}
          </label>
          : null
      }
    </div>
  );
}
